<template>
    <hts-drawer
        v-model="visible"
        :title="$t('labels.vehicleRepairAdd')"
        :loading="loading"
        @close="close">
        <hts-card>
            <hts-select-vehicle
                v-model="formData.vehicle"
                v-model:name="formData.licensePlate"
                :label="$t('labels.vehicle')"
                name-select="vehicle"
                prop="vehicle"
                readonly />

            <hts-form-date
                v-model="formData.repairDate"
                :label="$t('labels.repairDate')"
                name="repairDate"
                prop="repairDate"
                readonly />

            <hts-form-select
                v-model="formData.repairType"
                :label="$t('labels.repairType')"
                :items="repairTypes"
                key-id="key"
                key-label="label"
                readonly
                name="repairType"
                prop="repairType" />

            <hts-form-input
                v-model="formData.repairCost"
                type="number"
                :label="$t('labels.repairCost')"
                name="repairCost"
                prop="repairCost"
                readonly />

            <hts-select-cooperator
                v-model="formData.repairAgency"
                v-model:name="formData.repairAgencyAbbreviationName"
                :label="$t('labels.repairAgency')"
                type-cooperator="VENDOR"
                readonly
                prop="repairAgency"
                name-select="repairAgency"
                key-label="abbreviationName"
                key-sub-label="name" />

            <hts-form-textarea
                v-model="formData.description"
                :label="$t('labels.description')"
                name="description"
                prop="description"
                readonly />
            <!--  -->
            <!--
              <hts-form-file
              ref="file"
              v-model="formData.documents"
              type="file"
              :label="$t('labels.document')"
              name="document"
              prop="document"
              multiple />
            -->

            <p>
                {{ $t('labels.document') }}
            </p>
            <div
                v-for="document in formData.documents"
                :key="document">
                <a
                    target="_blank"
                    :href="document.url"
                    class="text-primary-500 hover:text-primary-600"
                    rel="noopener noreferrer">
                    {{ document.originalName }}
                </a>
            </div>
        </hts-card>
    </hts-drawer>
</template>
<script setup lang="ts">
const visible = ref(false)
const loading = ref(true)

const repairTypes = [
  {
    key: 'MAJOR_REPAIR',
    label: 'Sửa chữa lớn'
  },
  {
    key: 'MINOR_REPAIR',
    label: 'Sửa chữa nhỏ'
  }
]

const formData = ref<{ [key: string]: any }>({
  vehicle: '',
  licensePlate: '',
  repairDate: '',
  repairType: '',
  repairCost: null,
  repairAgency: '',
  repairAgencyAbbreviationName: '',
  description: '',
  documents: null
})

const open = (data: any) => {
  visible.value = true

  $api($url.vehicle.repair.getById, { uriParams: { ID: data._id || '' } }).then((response: any) => {
    const data = response?.data?.value?.data
    if (data) {
      formData.value = data
    }

    nextTick(() => {
      loading.value = false
    })
  })
}

const close = () => {
  visible.value = false
  loading.value = true
}

defineExpose({
  open
})
</script>
